import { trpc, queryClient } from '@/utils/trpc';
import { useQuery, useMutation } from '@tanstack/react-query';

interface ListProfilesParams {
  searchTerms?: string[];
  assignedProfilesOnly?: boolean;
  pagination?: {
    offset: number;
    limit: number;
  };
  sortColumns?: Array<{
    column: string;
    order?: 'asc' | 'desc';
  }>;
}

export const useListProfiles = (params?: ListProfilesParams) =>
  useQuery(
    trpc.organizationProfilesRouter.getOrganizationProfiles.queryOptions({
      ...params,
      pagination: {
        offset: params?.pagination?.offset ?? 0,
        limit: params?.pagination?.limit ?? 10,
      },
    }),
  );

export const useGetOrgProfileById = (organizationProfileId?: string) =>
  useQuery({
    ...trpc.organizationProfilesRouter.getOrganizationProfile.queryOptions(
      {
        organizationProfileId: organizationProfileId ?? '',
      },
      {
        enabled: !!organizationProfileId,
      },
    ),
  });

export const useUpdateProfile = () => {
  return useMutation({
    ...trpc.organizationProfilesRouter.updateOrganizationProfile.mutationOptions(),
    onSuccess: (_, variables) => {
      // Invalidate the specific profile query
      queryClient.invalidateQueries({
        queryKey:
          trpc.organizationProfilesRouter.getOrganizationProfile.queryKey({
            organizationProfileId: variables.organizationProfileId,
          }),
      });

      // Invalidate the profiles list to refresh the table
      queryClient.invalidateQueries({
        queryKey:
          trpc.organizationProfilesRouter.getOrganizationProfiles.queryKey(),
      });
    },
  });
};

export const useCreateProfile = () => {
  return useMutation({
    ...trpc.organizationProfilesRouter.createOrganizationProfile.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey:
          trpc.organizationProfilesRouter.getOrganizationProfiles.queryKey(),
      });
    },
  });
};
